module.exports = __webpack_public_path__ + "img/1.c9660aed.png";